import { Component, Input, OnInit, OnDestroy, NgZone, Inject, Optional } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { PershingTranslationService, PershingDecimalFormatPipe, LogService, ServiceRouter } from '@pershing/pershing-core';
import { DisclosureContentService } from '../../services/disclosure-content.service';

@Component({
    selector: 'disclosure-content',
    templateUrl: './disclosure-content.component.html',
    styleUrls: ['./disclosure-content.component.css']
})

export class DisclosureContentComponent implements OnInit, OnDestroy {
    articleId: string;
    communityName: string;
    @Input() hideTitle: boolean = false;
    isAda: boolean = false;
    constructor(private translationService: PershingTranslationService,
                private pershingDecimalPipe: PershingDecimalFormatPipe, private zone: NgZone,
                private logService: LogService, private sanitizer: DomSanitizer, private serviceRouter: ServiceRouter,
                private disclosureContentService: DisclosureContentService, @Optional() @Inject('AppSettings') appSettings: any) {
                    if (appSettings.themeType === 'ada') {
                        this.isAda = true;
                    }
                }

    ngOnInit(): void {
        this.articleId = this.disclosureContentService.getArticleIdForCurrentPage();
        this.communityName = this.disclosureContentService.getCommunityName();
        console.log('communityname from disclosure service' + this.communityName);
        console.log('articleId from disclosure service' + this.articleId);
    }

    ngOnDestroy(): void {

    }
}
